<template>
  <BaseCard flat>
    <BaseCardBody>
      <h3 class="text-sm">CRM: Saved query</h3>
      <p class="text-xs text-gray-500">
        {{ savedQuery.name }}
      </p>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
export default {
  props: {
    savedQuery: {
      type: Object,
      required: true,
    },
  },
};
</script>
